import './SelectedEntries.scss';
import { _ } from '../../Lang.class.js';
import './scrollbar.scss';
import type {Entry} from "./types";
import {Entries} from "./Entries";

type SelectedEntriesCallbacks = {
    onClickEntry: (entry: Entry) => void,
}

export class SelectedEntries extends Entries {

    private readonly root: HTMLDivElement;
    private readonly callbacks: SelectedEntriesCallbacks;

    constructor(root: HTMLDivElement, callbacks: SelectedEntriesCallbacks) {
        super();
        this.root = root;
        this.callbacks = callbacks;
        this.render();
    }
    
    
    public getCount(): number {
        return this.entries.length;
    }

    private render(): void {
        this.root.innerHTML = this.getHTML();
    }

    public populate(entries: Entry[]): void {
        super.populate(entries);
        this.redraw();
    }

    public redraw(): void {
        const entriesList = this.root.querySelector('.selected-entries-list');
        entriesList.innerHTML = '';
        this.entries.forEach(entry => {
            const entryElement = document.createElement('div') as HTMLDivElement;
            entryElement.classList.add('entry');
            entryElement.dataset.id = entry.id.toString();
            entryElement.innerHTML = `
            <div class="entry-container">
                <div class="entry-name">${_(entry.name)}</div>
                <div class="entry-remove"></div>
            </div>`;
            entriesList.appendChild(entryElement);

            // Remove entry on click
            entryElement.addEventListener('click', () => {
                this.callbacks.onClickEntry(entry);
            });
        });
    }

    public filter(searchString: string): void {
        const entries = this.root.querySelectorAll('.entry');
        entries.forEach(entry => {
            if (searchString !== '' && entry.querySelector('.entry-name').innerHTML.toLowerCase().indexOf(searchString.toLowerCase()) === -1) {
                entry.classList.add('hidden');
            } else {
                entry.classList.remove('hidden');
            }
        });
    }

    private getHTML(): string {
        return `
            <div class="selected-entries-list"></div>
        `;
    }

}
